export default "__VITE_ASSET__c152719e__"